//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
// Images
//import bgImage from "assets/images/strategia.jpg";
import { Card, CardContent, Typography, Button, TextField } from "@mui/material";
//import RotatingCard from "./RotatingCard";
//import RotatingCardFront from "./RotatingCardFront";
//import RotatingCardBack from "./RotatingCardBack";
//import { useTranslation } from "react-i18next";
//import bgFront from "assets/images/rotating-card-bg-front.jpeg";
//import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import { FormControl, Select, MenuItem } from "@mui/material";
import {
  FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY,
  CREATE_STRATEGYCOMMENT,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
import ReCAPTCHA from "react-google-recaptcha";
//import Box from "@mui/material/Box";
//import Slider from "@mui/material/Slider";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Strategycommentsopen = ({ selectedKunta, setError, categories, cookies, roles }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  const [idea, setIdea] = useState("");
  const [name, setName] = useState("");
  const [born, setBorn] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  // eslint-disable-next-line
    const [submitted, setSubmitted] = useState(false);
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  const [ideatext, setIdeatext] = useState("");
  const [categ, setCateg] = useState([{ name: "Visio", text: "" }]);
  const [selectedIdea, setSelectedIdea] = useState(categ[0].text);
  const [votes, setVotes] = useState([]);
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  const [scomments, setScomments] = useState([]);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = "anonym";
    if (localStorage.getItem("id") !== undefined) {
      id = localStorage.getItem("id");
    }
    //console.log(id);
    ReactGA.event({
      category: "Strategycomments",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    }); // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/
    //console.log(categories);
    let cat = categories.split("|||");
    //console.log(cat);
    let c = [];
    if (cat.length > 0) {
      for (let i = 0; i < cat.length + 1; i++) {
        if (i % 2 === 0) {
          c.push({ name: cat[i], text: cat[i + 1] });
        }
      }
      setCateg(c);
    } else {
      setCateg(content);
    }
  }, []);
  const [createStrategycomment] = useMutation(CREATE_STRATEGYCOMMENT, {
    refetchQueries: [
      { query: FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const scommentssw = useQuery(FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });

  useEffect(() => {
    let scommentss = [];
    //console.log(scommentssw);
    //let municipalitiess = [];
    if (scommentssw.data) {
      scommentss = scommentssw.data.findStrategyCommentsByMunicipality;
      //setOrgans(organss);
      //console.log(scommentss);
      //let secs = scommentss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setscomments(secs);
      setScomments(scommentss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [scommentssw]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    createStrategycomment({
      variables: {
        strategytext: idea,
        info: name + "|||" + born + "|||" + gender + "|||" + role,
        strategyclass: selectedIdea,
        strategydatetime: pvm.toString(),
        municipality: selectedKunta,
        userid: "anonym",
      },
    });
    setSelectedIdea("");
    setName("");
    setBorn("");
    setGender("");
    setRole("");
    setIdea("");
    window.confirm("Kiitos kommentistasi");
    setVerified(!verified);
  };

  const content = [
    {
      name: t("strategy.vision"),
      text: t("strategy.visiontext"),
    },
    {
      name: t("strategy.vitality"),
      text: t("strategy.vitalitytext"),
    },
    {
      name: t("strategy.wellbeing"),
      text: t("strategy.wellbeingtext"),
    },
    {
      name: t("strategy.nature"),
      text: t("strategy.naturetext"),
    },
    {
      name: t("strategy.involving"),
      text: t("strategy.involvingtext"),
    },
    {
      name: t("strategy.economy"),
      text: t("strategy.economytext"),
    },
    {
      name: t("strategy.evaluation"),
      text: t("strategy.evaluationtext"),
    },
    {
      name: t("strategy.action"),
      text: t("strategy.actiontext"),
    },
  ];

  useEffect(() => {
    let filtered = categ.filter((cont) => {
      return cont.name === selectedIdea;
    });
    //console.log(selectedIdea);
    //console.log(filtered);
    if (filtered.length > 0) {
      setIdeatext(filtered[0].text);
    }
  }, [selectedIdea]);
  const getAiheet = () =>
    categ.map((aihe) => {
      return (
        <MenuItem value={aihe.name} key={aihe.name}>
          {aihe.name}
        </MenuItem>
      );
    });

  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategycommentid: event,
        userid: cookies.toString(),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategycommentid === p).length;
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <FormControl style={{ minWidth: 220 }}>
            Syntymävuosi
            <Select
              labelId="born"
              id="born"
              value={born}
              onChange={({ target }) => setBorn(target.value)}
            >
              <MenuItem value={""}>ei valittu</MenuItem>
              <MenuItem value={"2023"}>2023</MenuItem>
              <MenuItem value={"2022"}>2022</MenuItem>
              <MenuItem value={"2021"}>2021</MenuItem>
              <MenuItem value={"2020"}>2020</MenuItem>
              <MenuItem value={"2019"}>2019</MenuItem>
              <MenuItem value={"2018"}>2018</MenuItem>
              <MenuItem value={"2017"}>2017</MenuItem>
              <MenuItem value={"2016"}>2016</MenuItem>
              <MenuItem value={"2015"}>2015</MenuItem>
              <MenuItem value={"2014"}>2014</MenuItem>
              <MenuItem value={"2013"}>2013</MenuItem>
              <MenuItem value={"2012"}>2012</MenuItem>
              <MenuItem value={"2011"}>2011</MenuItem>
              <MenuItem value={"2010"}>2010</MenuItem>
              <MenuItem value={"2009"}>2009</MenuItem>
              <MenuItem value={"2008"}>2008</MenuItem>
              <MenuItem value={"2007"}>2007</MenuItem>
              <MenuItem value={"2006"}>2006</MenuItem>
              <MenuItem value={"2005"}>2005</MenuItem>
              <MenuItem value={"2004"}>2004</MenuItem>
              <MenuItem value={"2003"}>2003</MenuItem>
              <MenuItem value={"2002"}>2002</MenuItem>
              <MenuItem value={"2001"}>2001</MenuItem>
              <MenuItem value={"2000"}>2000</MenuItem>
              <MenuItem value={"1999"}>1999</MenuItem>
              <MenuItem value={"1998"}>1998</MenuItem>
              <MenuItem value={"1997"}>1997</MenuItem>
              <MenuItem value={"1996"}>1996</MenuItem>
              <MenuItem value={"1995"}>1995</MenuItem>
              <MenuItem value={"1994"}>1994</MenuItem>
              <MenuItem value={"1993"}>1993</MenuItem>
              <MenuItem value={"1992"}>1992</MenuItem>
              <MenuItem value={"1991"}>1991</MenuItem>
              <MenuItem value={"1990"}>1990</MenuItem>
              <MenuItem value={"1989"}>1989</MenuItem>
              <MenuItem value={"1988"}>1988</MenuItem>
              <MenuItem value={"1987"}>1987</MenuItem>
              <MenuItem value={"1986"}>1986</MenuItem>
              <MenuItem value={"1985"}>1985</MenuItem>
              <MenuItem value={"1984"}>1984</MenuItem>
              <MenuItem value={"1983"}>1983</MenuItem>
              <MenuItem value={"1982"}>1982</MenuItem>
              <MenuItem value={"1981"}>1981</MenuItem>
              <MenuItem value={"1980"}>1980</MenuItem>
              <MenuItem value={"1979"}>1979</MenuItem>
              <MenuItem value={"1978"}>1978</MenuItem>
              <MenuItem value={"1977"}>1977</MenuItem>
              <MenuItem value={"1976"}>1976</MenuItem>
              <MenuItem value={"1975"}>1975</MenuItem>
              <MenuItem value={"1974"}>1974</MenuItem>
              <MenuItem value={"1973"}>1973</MenuItem>
              <MenuItem value={"1972"}>1972</MenuItem>
              <MenuItem value={"1971"}>1971</MenuItem>
              <MenuItem value={"1970"}>1970</MenuItem>
              <MenuItem value={"1969"}>1969</MenuItem>
              <MenuItem value={"1968"}>1968</MenuItem>
              <MenuItem value={"1967"}>1967</MenuItem>
              <MenuItem value={"1966"}>1966</MenuItem>
              <MenuItem value={"1965"}>1965</MenuItem>
              <MenuItem value={"1964"}>1964</MenuItem>
              <MenuItem value={"1963"}>1963</MenuItem>
              <MenuItem value={"1962"}>1962</MenuItem>
              <MenuItem value={"1961"}>1961</MenuItem>
              <MenuItem value={"1960"}>1960</MenuItem>
              <MenuItem value={"1959"}>1959</MenuItem>
              <MenuItem value={"1958"}>1958</MenuItem>
              <MenuItem value={"1957"}>1957</MenuItem>
              <MenuItem value={"1956"}>1956</MenuItem>
              <MenuItem value={"1955"}>1955</MenuItem>
              <MenuItem value={"1954"}>1954</MenuItem>
              <MenuItem value={"1953"}>1953</MenuItem>
              <MenuItem value={"1952"}>1952</MenuItem>
              <MenuItem value={"1951"}>1951</MenuItem>
              <MenuItem value={"1950"}>1950</MenuItem>
              <MenuItem value={"1949"}>1949</MenuItem>
              <MenuItem value={"1948"}>1948</MenuItem>
              <MenuItem value={"1947"}>1947</MenuItem>
              <MenuItem value={"1946"}>1946</MenuItem>
              <MenuItem value={"1945"}>1945</MenuItem>
              <MenuItem value={"1944"}>1944</MenuItem>
              <MenuItem value={"1943"}>1943</MenuItem>
              <MenuItem value={"1942"}>1942</MenuItem>
              <MenuItem value={"1941"}>1941</MenuItem>
              <MenuItem value={"1940"}>1940</MenuItem>
              <MenuItem value={"1939"}>1939</MenuItem>
              <MenuItem value={"1938"}>1938</MenuItem>
              <MenuItem value={"1937"}>1937</MenuItem>
              <MenuItem value={"1936"}>1936</MenuItem>
              <MenuItem value={"1935"}>1935</MenuItem>
              <MenuItem value={"1934"}>1934</MenuItem>
              <MenuItem value={"1933"}>1933</MenuItem>
              <MenuItem value={"1932"}>1932</MenuItem>
              <MenuItem value={"1931"}>1931</MenuItem>
              <MenuItem value={"1930"}>1930</MenuItem>
              <MenuItem value={"1929"}>1929</MenuItem>
              <MenuItem value={"1928"}>1928</MenuItem>
              <MenuItem value={"1927"}>1927</MenuItem>
              <MenuItem value={"1926"}>1926</MenuItem>
              <MenuItem value={"1925"}>1925</MenuItem>
              <MenuItem value={"1924"}>1924</MenuItem>
              <MenuItem value={"1923"}>1923</MenuItem>
              <MenuItem value={"1922"}>1922</MenuItem>
              <MenuItem value={"1921"}>1921</MenuItem>
              <MenuItem value={"1920"}>1920</MenuItem>
              <MenuItem value={"1919"}>1919</MenuItem>
              <MenuItem value={"1918"}>1918</MenuItem>
              <MenuItem value={"1917"}>1917</MenuItem>
              <MenuItem value={"1916"}>1916</MenuItem>
              <MenuItem value={"1915"}>1915</MenuItem>
              <MenuItem value={"1914"}>1914</MenuItem>
              <MenuItem value={"1913"}>1913</MenuItem>
              <MenuItem value={"1912"}>1912</MenuItem>
              <MenuItem value={"1911"}>1911</MenuItem>
              <MenuItem value={"1910"}>1910</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ minWidth: 220 }}>
            Sukupuoli
            <Select
              labelId="gender"
              id="gender"
              value={gender}
              onChange={({ target }) => setGender(target.value)}
              inputProps={{
                MenuProps: {
                  MenuListProps: {
                    sx: {
                      backgroundColor: "white",
                    },
                  },
                },
              }}
            >
              <MenuItem value={"ei valitt"}>ei valittu</MenuItem>
              <MenuItem value={"nainen"}>Nainen</MenuItem>
              <MenuItem value={"mies"}>Mies</MenuItem>
              <MenuItem value={"muu"}>Muu</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ minWidth: 220 }}>
            Rooli
            <Select
              labelId="role"
              id="role"
              value={role}
              onChange={({ target }) => setRole(target.value)}
            >
              {roles.map((item) => (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <br />
          <br />
          <TextField
            label="Nimi"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <br />
          <br />
          {t("strategy.selectcategory")}
          <br />
          <FormControl fullWidth>
            <Select
              displayEmpty
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedIdea}
              onChange={(e) => setSelectedIdea(e.target.value)}
            >
              {getAiheet()}
            </Select>
          </FormControl>
          <br />
          <br />
          <Typography variant="h5" gutterBottom>
            {selectedIdea}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {ideatext}
          </Typography>
          <br />
          <br />
          <Typography variant="h6" gutterBottom>
            {t("strategy.sharecomment")}
          </Typography>
          <TextField
            label={t("strategy.writeidea")}
            multiline
            fullWidth
            minRows={3}
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <br />
          <br />
          <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
          <br />
          <br />
          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={handleSubmit}
            disabled={!verified}
            submitted={submitted}
          >
            {t("strategy.savecomment")}
          </Button>
        </CardContent>
      </Card>
      <MKTypography variant="h4" gutterBottom>
        {t("strategy.commentwall")}
      </MKTypography>
      {scomments.length === 0 && <MKTypography>{t("strategy.noideas")}</MKTypography>}
      {scomments.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {item.strategyclass}: {item.strategytext}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Strategycommentsopen;
/**
 * 
 * import React, { useState } from "react";
import { Card, CardContent, Typography, Button, TextField } from "@mui/material";

export default function ParticipationDemo() {
  const [idea, setIdea] = useState("");
  const [ideas, setIdeas] = useState([]);

  const handleSubmit = () => {
    if (idea.trim()) {
      setIdeas([{ text: idea, votes: 0 }, ...ideas]);
      setIdea("");
    }
  };

  const handleVote = (index) => {
    const updatedIdeas = [...ideas];
    updatedIdeas[index].votes++;
    setIdeas(updatedIdeas);
  };

  return (
    <div style={{ padding: "1rem", maxWidth: "600px", margin: "0 auto" }}>
      <Typography variant="h4" gutterBottom>
        Osallistu kuntastrategian valmisteluun
      </Typography>

      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Jaa ideasi
          </Typography>
          <TextField
            label="Kirjoita ideasi tähän"
            multiline
            fullWidth
            minRows={3}
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <Button variant="contained" onClick={handleSubmit}>
            Lähetä idea
          </Button>
        </CardContent>
      </Card>

      <Typography variant="h6" gutterBottom>
        Ideaseinä
      </Typography>
      {ideas.length === 0 && <Typography>Ei vielä ideoita.</Typography>}
      {ideas.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography>{item.text}</Typography>
            <Button variant="outlined" onClick={() => handleVote(index)}>
              👍 {item.votes}
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
 */
/**
 * 
 * <Box sx={{ width: "100%" }}>
                Lapset ja nuoret
                <Slider
                  aria-label="Lapset ja nuoret"
                  defaultValue={limit1}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit1(e.target.value)}
                  onDragStop={(e) => handleLimit1(e.target.value)}
                />
                Seniorit
                <Slider
                  aria-label="Seniorit"
                  defaultValue={limit2}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit2(e.target.value)}
                />
                Liikunta ja vapaa-aika
                <Slider
                  aria-label="Liikunta ja vapaa-aika"
                  defaultValue={limit3}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit3(e.target.value)}
                />
                Kulttuuri
                <Slider
                  aria-label="Kulttuuri"
                  defaultValue={limit4}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit4(e.target.value)}
                />
 */
/**
 * 
 *   function handleLimit1(value) {
    if (limit - value > -1) {
      setLimit1(value);
    } else {
      setLimit1(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }

  function handleLimit2(value) {
    if (limit - value > -1) {
      setLimit2(value);
    } else {
      setLimit2(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }
  function handleLimit3(value) {
    if (limit - value > -1) {
      setLimit3(value);
    } else {
      setLimit3(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(0);
    } else {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    }
    setLimit(100 - limit1 - limit2 - limit3 - limit4);
    //console.log(limit);
  }
  function handleLimit4(value) {
    if (limit - value > -1) {
      setLimit4(value);
    } else {
      setLimit4(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }

 */
